import { render, staticRenderFns } from "./CASEFVMoreInfo.vue?vue&type=template&id=b4c1e39e"
import script from "./CASEFVMoreInfo.vue?vue&type=script&lang=js"
export * from "./CASEFVMoreInfo.vue?vue&type=script&lang=js"
import style0 from "./CASEFVMoreInfo.vue?vue&type=style&index=0&id=b4c1e39e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports